import { useTranslation } from 'react-i18next';

import { getInterviewerColor } from '@/lib/interviewerColors';
import { cn } from '@/lib/utils';

import type { Interviewer } from '@/types/scheduling.types';

interface InterviewerFilterProps {
  interviewers: Interviewer[];
  activeIds: Set<string>;
  onToggle: (userId: string) => void;
  onToggleAll: () => void;
}

export function InterviewerFilter({ interviewers, activeIds, onToggle, onToggleAll }: InterviewerFilterProps) {
  const { t } = useTranslation();
  const isAllActive = activeIds.size === interviewers.length;

  return (
    <div className='flex flex-wrap items-center gap-2'>
      <button
        onClick={onToggleAll}
        className={cn(
          'rounded-full px-3 py-1 text-sm font-medium transition-colors',
          isAllActive ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-500 opacity-70 hover:opacity-100',
        )}>
        {t('scheduling.interviewers.all')}
      </button>

      {interviewers.map((interviewer) => {
        const color = getInterviewerColor(interviewer.userId);
        const isActive = activeIds.has(interviewer.userId);

        return (
          <button
            key={interviewer.userId}
            onClick={() => onToggle(interviewer.userId)}
            className={cn(
              'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-medium transition-colors',
              isActive ? 'bg-white ring-2 ring-gray-300' : 'bg-gray-100 text-gray-500 opacity-50 hover:opacity-75',
            )}>
            <div className='h-2 w-2 shrink-0 rounded-full' style={{ backgroundColor: color.hex }} />
            {interviewer.name}
          </button>
        );
      })}
    </div>
  );
}
